import { ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function LoginBrandPanel() {
  return (
    <div className="hidden lg:flex flex-col justify-between bg-[#0F172A] text-white p-12 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-teal-500/20 blur-3xl" />
      <div className="absolute bottom-0 -left-24 w-96 h-96 rounded-full bg-blue-500/10 blur-3xl" />
      <div className="flex items-center gap-3 relative z-10">
        <Link to="/" data-testid="login-brand-home-link" className="flex items-center gap-3 hover:opacity-90">
          <Logo size="h-11 w-11" />
          <span className="text-xl font-head font-bold tracking-tight">Shri Ji Clinic</span>
        </Link>
      </div>
      <div className="relative z-10 space-y-6">
        <h1 className="font-head text-4xl xl:text-5xl font-extrabold leading-tight tracking-tight">
          Appointments & receipts, <span className="text-teal-400">beautifully organised.</span>
        </h1>
        <p className="text-slate-300 text-base max-w-md leading-relaxed">
          Book patient visits, track every consultation, and generate crisp printable receipts with prescriptions — all from one clinical dashboard.
        </p>
        <div className="flex items-center gap-2 text-sm text-slate-400"><ShieldCheck className="h-4 w-4 text-teal-400" /> Secure staff access only</div>
      </div>
      <div className="relative z-10 text-xs text-slate-500 font-mono">© 2026 Shri Ji Clinic</div>
    </div>
  );
}
